<script>
import { check_rules } from "./check-rules";
import {
  UiCompletionStepper,
  UiCompletionCard,
  UiCompletionLine,
  UiCompletionList,
} from "@/components/ui/completion/";

export default {
  name: "ChannelsIndicator",
  components: {
    UiCompletionStepper,
    UiCompletionCard,
    UiCompletionLine,
    UiCompletionList,
  },
  props: {
    channels: {},
  },
  data: function () {
    return {
      rules: this.check_rules(this.channels),
    };
  },
  methods: {
    check_rules,
    rulesIncludes(rule) {
      return this.rules?.stack.includes(rule)
    },
  },
  watch: {
    channels: {
      handler: function (newChannels) {
        this.rules = this.check_rules(newChannels)
      },
      deep: true
    },
  },
}
</script>

<template>
  <UiCompletionCard>
    <div class="d-flex align-items-center mb-2 gap-2">
      <UiCompletionStepper :steps="rules.max" :current="rules.rules_length" :status="rules.stepper_status" />
      <strong class="ml-2">
        <span v-if="rules.status === 'none'" v-text="$t('watchmen.channels.indicator.none')"></span>
        <span v-if="rules.status === 'low'" v-text="$t('watchmen.channels.indicator.low')"></span>
        <span v-if="rules.status === 'complete'" v-text="$t('watchmen.channels.indicator.complete')"></span>
      </strong>
    </div>
    <UiCompletionList>
      <UiCompletionLine :is_completed="rulesIncludes('one_mobile')">
        {{$t('watchmen.channels.indicator.one_mobile')}}
      </UiCompletionLine>
      <UiCompletionLine :is_completed="rulesIncludes('two_watchmen')">
        {{$t('watchmen.channels.indicator.two_watchmen')}}
      </UiCompletionLine>
      <UiCompletionLine :is_completed="rulesIncludes('has_validated')">
        {{$t('watchmen.channels.indicator.has_validated')}}
      </UiCompletionLine>
    </UiCompletionList>
  </UiCompletionCard>
</template>
